export const lockingControllerAbi = [
    {
        inputs: [
            {
                internalType: "uint32",
                name: "weeks",
                type: "uint32",
            },
        ],
        name: "exchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
] as const;
